/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, Fragment, useEffect, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { KTSVG } from '../../../../_metronic/helpers'
import { EnableSidebar } from '../../../../_metronic/layout/core'
import { PDFCard } from '../../../../_metronic/partials/content/cards/PDFCard'
import { PDFLinkCard } from '../../../../_metronic/partials/content/cards/PDFLinkCard'
import { FullPublicationModel } from '../../auth'
import { getPDFURL, loadFullPersonalPublication } from '../../auth/core/_api'

function getHeader(header: string) {
  return <h4 className='p-2 text-gray-800 fw-bolder mt-10 bg-light-primary rounded border'>{header}</h4>
}

function getEducationText(eduCode:string) {
  if(eduCode == "undefined"){
    return "ไม่ระบุ/ผลงานพนักงาน";
  }
  else if(eduCode == "bachelor"){
    return "ปริญญาตรี";
  }
  else if(eduCode == "master"){
    return "ปริญญาโท";
  }
  else if(eduCode == "doctor"){
    return "ปริญญาเอก";
  }
  else{
    return eduCode;
  }
}

function getSingleBlock(header: string, text: string) {
  return <>
    <div className='fs-4 fw-normal text-gray-800 mb-10 mt-10'>
      {getHeader(header)}
      <div className='notice rounded border-primary border border-dashed p-4'>
        {text}
      </div>
    </div>
  </>
}

function getDoubleBlock(header: string, th_string: string, en_string: string) {
  return <>
    {getHeader(header)}
    <div className='notice rounded border-primary border border-dashed ps-2 pe-2'>
      <div className='d-flex w-100 mt-3'>
        <div className='d-flex h-50px w-50px flex-shrink-0 flex-center position-relative'>
          <KTSVG
            path='/media/icons/duotune/abstract/abs051.svg'
            className='svg-icon-primary position-absolute opacity-15'
            svgClassName='h-40px w-40px'
          />
          TH
        </div>
        <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
          <div className='mt-0 mb-md-0 fw-bold'>
            <div className='fs-6 text-gray-600 pe-7'>
              {th_string}
            </div>
          </div>
        </div>
      </div>

      <div className='d-flex w-100 mb-2 mt-4'>
        <div className='d-flex h-50px w-50px flex-shrink-0 flex-center position-relative'>
          <KTSVG
            path='/media/icons/duotune/abstract/abs051.svg'
            className='svg-icon-primary position-absolute opacity-15'
            svgClassName='h-40px w-40px'
          />
          EN
        </div>
        <div className='d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap'>
          <div className='mt-0 mb-md-0 fw-bold'>
            <div className='fs-6 text-gray-600 pe-7'>
              {en_string}
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
}

const Article: React.FC = () => {
  const [articleName, setArticleName] = useState('')
  const [pdfFile, setPdfFile] = useState('')
  const [articles, setArticles] = useState<{title:string, th_text:string, en_text:string}[]>()
  const [searchParams, setSearchParams] = useSearchParams();

  const checkNull = (input:string) => {
    return (input != (null && ''))?input:''
  }

  const checkNullWithDefault = (input:string) => {
    return (input != (null && ''))?input:'-'
  }

  const getDoubleDisplay = (title:string, th:string, en:string) => {
    if(checkNull(th) != '' && checkNull(en) != ''){
      return {
        title: `${title}`,
        th_text: `${checkNull(th)}`,
        en_text: `${checkNull(en)}`
      }
    }
    else{
      return getSingleDisplay(title, th)
    }
  }

  const getSingleDisplay = (title:string, th:string) => {
    return {
      title: `${title}`,
      //th_text: `${checkNullWithDefault(th)}`,
      th_text: `${checkNull(th)}`,
      en_text: ``
    }
  }

  useEffect(() => {
    async function loadPublication(pid:string | null) {
      const publication = await loadFullPersonalPublication(pid)
      const p:FullPublicationModel = publication.data.publication

      setArticleName((p.title_th)?p.title_th:p.title_en)
      if(p.pdf_file)setPdfFile(p.pdf_file)
      
      var arr = [
        getDoubleDisplay(`หัวข้อวิทยานิพนธ์`, p.title_th, p.title_en),
        getSingleDisplay(`รายละเอียด`, p.description),
        getSingleDisplay(`หมายเลขอ้างอิง`, p.reference),
        getSingleDisplay(`ชื่อผู้เขียน`, p.contributor),
        getSingleDisplay(`อาจารย์ที่ปรึกษา`, p.advisor),
        getDoubleDisplay(`บทคัดย่อ`, p.abstract_th, p.abstract_en),
        getSingleDisplay(`ปีที่เผยแพร่`, p.public_year),
        getSingleDisplay(`ระดับการศึกษา`, getEducationText(p.degree_level)),
        getSingleDisplay(`ชื่อปริญญา`, p.degree_name),
        getSingleDisplay(`สาขาวิชา`, p.major_name),
        getSingleDisplay(`ปีการศึกษา`, p.academic_year),
        getSingleDisplay(`คำสำคัญ`, p.keyword),
      ]
      setArticles(arr)
    }

    if(searchParams && searchParams.get('pid')){
      //alert(searchParams.get('pid'))
      if(searchParams.get('pid') != null){
          loadPublication(searchParams.get('pid'))
      }
    }
    
  }, []);

  return (
    <EnableSidebar>
      <div className='mb-0'>
        <div className='d-flex flex-stack flex-wrap'>
          <div className='d-flex align-items-center py-1'>
            <div className='symbol symbol-35px me-2'>
              <PDFLinkCard icon='/media/svg/files/pdf.svg' title='view' url={(pdfFile)?getPDFURL(pdfFile):"#"} />
            </div>

            <div className='d-flex flex-column align-items-start justify-content-center'>
              <h1 className='fs-2x fw-bolder text-gray-900 mb-0 me-1'>
                {articleName}
              </h1>
            </div>
          </div>
        </div>

        <div className='d-flex align-items-center mb-9'>
          <div className='d-flex align-items-center'>
            <span className='ms-1' data-bs-toggle='tooltip' title='User replied'>
              <KTSVG
                path='media/icons/duotune/general/gen043.svg'
                className='svg-icon-success svg-icon-1'
              />
            </span>
          </div>
        </div>

        {articles && articles.map((a, i) => {
          return ((a.th_text || a.en_text) &&
            <Fragment key={`article_${i}`}>
              {(a.en_text) ? getDoubleBlock(a.title, a.th_text, a.en_text) : getSingleBlock(a.title, a.th_text)}
            </Fragment>
          )
        })}

        <div className='d-flex flex-stack flex-wrap mt-2'>
          <div className='d-flex align-items-center py-1'>
            <i className='bi bi-clock me-2 fs-2'></i>

            <div className='d-flex flex-column align-items-start justify-content-center mt-1'>
              <span className='text-gray-800 fs-7 fw-bold lh-1 mb-2'>last update</span>
              <span className='text-muted fs-8 fw-bold lh-1'>24 minutes ago</span>
            </div>
          </div>

        </div>
      </div>

      <div className='separator separator-dashed border-gray-300 mt-8 mb-10'></div>

    </EnableSidebar>
  )
}

export { Article }
